module.exports = __webpack_public_path__ + "static/assets/89f7d0e06033eb68d430b01e7ac9d4f8.svg";